module.exports = __webpack_public_path__ + "static/media/hong1 (2).035fe5d5.jpg";